/* import __COLOCATED_TEMPLATE__ from './opt-in-messaging.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let TwoFactorModalSmsBlockedOptInMessaging = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class TwoFactorModalSmsBlockedOptInMessaging extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor4, this);
    _initializerDefineProperty(this, "loading", _descriptor5, this);
  }
  async optInMessaging() {
    try {
      this.loading = true;
      await this.multipassfeClient.managePhoneDetail({
        phone: this.args.selectedDetail.sms.phone,
        action: this.multipassfeClient.constants.MANAGE_PHONE_DETAIL_ACTIONS.UNBLOCK
      });
      this.args.next();
    } catch (e) {
      this.logger.sentryError(e);
      this.marketToasts.critical(this.intl.t(this.args.tPrefix + 'two_factor_modals.toasts.errors.unknown'));
    } finally {
      this.loading = false;
    }
  }
  close() {
    this.args.close();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "optInMessaging", [action], Object.getOwnPropertyDescriptor(_class.prototype, "optInMessaging"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _class);
export { TwoFactorModalSmsBlockedOptInMessaging as default };